<script>
  // import Analytics from "./Analytics.Head.svelte";
  import copy from "../data/doc.json";
  const { meta } = copy;
</script>

<svelte:head>
  <title>{meta.title}</title>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
  <meta name="description" content="{meta.description}" />
  <meta name="author" content="SiriusXM Media" />
  <meta name="news_keywords" content="{meta.keywords}" />

  <meta property="og:title" content="{meta.title}" />
  <meta property="og:site_name" content="SiriusXM Media" />
  <meta property="og:url" content="{meta.url}" />
  <meta property="og:description" content="{meta.description}" />
  <meta property="og:type" content="article" />
  <meta property="og:locale" content="en_US" />

  <meta property="og:image" content="{meta.url}/assets/social/facebook.png" />
  <meta property="og:image:type" content="image/png" />
  <meta property="og:image:width" content="1200" />
  <meta property="og:image:height" content="628" />

  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:site" content="https://www.siriusxmmedia.com" />
  <meta name="twitter:creator" content="{meta.twitter}" />
  <meta name="twitter:title" content="{meta.title}" />
  <meta name="twitter:description" content="{meta.description}" />
  <meta
    name="twitter:image:src"
    content="{meta.url}/assets/social/twitter.png"
  />

  <meta name="robots" content="max-image-preview:large" />

  <link rel="canonical" href="{meta.url}/" />
</svelte:head>
